import React, { useEffect, useState } from "react";
import Modal from "../../components/Modal";
import TextField from "../../components/TextField";
import Button from "../../components/Button";
import { ReactComponent as UserPlus } from "../../assets/icons/user_plus.svg";
import { ReactComponent as Envelope } from "../../assets/icons/envelope.svg";
import { ReactComponent as Lock } from "../../assets/icons/lock.svg";
import { ReactComponent as Eye } from "../../assets/icons/eye.svg";
import { ReactComponent as Graduation } from "../../assets/icons/graduation.svg";
import {
  isValid,
  IS_EMAIL,
  IS_UNIQUE,
  REQUIRED,
  validate,
} from "../../utils/Validation";
import { checkEmail } from "../../api/User";
import ImageUpload from "../../components/ImageUpload";
import { baseUrl } from "../../api/Client";
import SelectField from "../../components/SelectField";


const ROLES = [
  { value: "USER", label: "Usuário" },
  { value: "TEACHER", label: "Professor" },
  { value: "ADMIN", label: "Administrador" },
];

export default function EditUser({ selected, onClose, onSave }) {
  const [user, setUser] = useState({
    name: "",
    email: "",
    password: "",
    avatar: null,
    role: "USER",
  });
  const [show, setShow] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setUser(selected);
    setShow(selected != null);
    setErrors({});
    setSubmitting(false);
  }, [selected]);

  const clear = () => {
    setUser({
      name: "",
      email: "",
      password: "",
      role: "USER",
      avatar: null,
    });
    setErrors({});
    setSubmitting(false);
  };

  const save = async () => {
    setSubmitting(true);
    const rules = {
      name: REQUIRED,
      email: [IS_EMAIL, IS_UNIQUE(checkEmail)],
      role: REQUIRED,
    };
    const errors = await validate(rules, user);
    if (isValid(errors)) {
      onSave(user);
    } else {
      setErrors(errors);
    }
    setSubmitting(false);
  };

  return (
    <Modal
      visible={show}
      onClose={() => {
        clear();
        onClose();
      }}
      title={user?.id ? "Editar Usuário" : "Novo Usuário"}
      Action={<Button disabled={submitting} submitting={submitting} onClick={() => save()}>Cadastrar</Button>}
    >
      <TextField
        className="mb-5"
        Icon={UserPlus}
        placeholder="Insira um nome"
        value={user}
        field="name"
        update={setUser}
        errors={errors}
      />
      <TextField
        className="mb-5"
        Icon={Envelope}
        placeholder="Insira um e-mail válido"
        value={user}
        field="email"
        update={setUser}
        errors={errors}
      />
      <TextField
        type={showPassword ? "text" : "password"}
        autoComplete="new-password"
        className="mb-11"
        Icon={Lock}
        ActionIcon={() => (
          <button onClick={() => setShowPassword((p) => !p)}>
            <Eye />
          </button>
        )}
        placeholder="Escolha uma senha"
        value={user}
        field="password"
        update={setUser}
        errors={errors}
      />
      <SelectField
        className="mt-12 mb-12"
        label="Papel"
        errors={errors}
        field="role"
        Icon={Graduation}
        options={ROLES}
        update={setUser}
        value={user}
      />

      <h2 className="font-bold text-white text-lg">Foto do usuário</h2>
      <ImageUpload
        value={
          user?.avatar
            ? user?.avatar
            : user?.id
            ? `${baseUrl}/img/avatar/${user?.id}/200/200`
            : null
        }
        onChange={(image) =>
          setUser((u) => {
            let user = { ...u };
            user.avatar = image;
            return user;
          })
        }
      />
      <div className="h-20" />
    </Modal>
  );
}
